<fieldset class="fieldset" [class.selected]="shouldShowActions">
    <legend class="legend" [class.selected]="shouldShowActions">
        {{ 'mimic.settings.buttons.action.legend' | translate }}
    </legend>
    <mat-label class="lable" *ngIf="!selectedAction">{{ 'mimic.settings.buttons.action.label' | translate }}</mat-label>
    <mat-select
        class="button-actions-select"
        [panelClass]="{
            'panel-button-actions': selectedAction,
            'left-button-panel': !selectedAction,
        }"
        [(ngModel)]="selectedAction"
        (selectionChange)="actionSelected($event)"
        (openedChange)="shouldShowActions = !shouldShowActions">
        <mat-option *ngFor="let action of actionList" [value]="action" class="action-option">
            {{ action.translateString | translate }}
        </mat-option>
    </mat-select>
</fieldset>
